import { Button, Image, Popover, Tag } from "antd";
import React from "react";
import "../../../../App.css";
import editIcon from "../../../../assets/icons/edit.svg";
import noteIcon from "../../../../assets/icons/note.svg";
import { colors } from "../../utils/colors";

export const getColumns = ({
  editDetail,
  popoverContent,
  redirect,
  getNotesById,
  setIsEdit,
}) => [
    {
      title: "Agent Name",
      key: "1",
      dataIndex: "ACAG_Name",
      width: "11.11%",
      render: (_, object) => {
        return (
          <Button type="link" onClick={() => redirect(object.ACAG_KeyID)}>
            <span
              title={object.ACAG_Name}
              style={{
                display: "inline-block",
                maxWidth: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                verticalAlign: "bottom",
              }}
            >
              {object.ACAG_Name}
            </span>
          </Button>
        );
      },
    },
    {
      title: "Agent Email",
      key: "9",
      dataIndex: "ACAG_Email",
      width: "11.11%",
      ellipsis: true,
      render: (value) => <span title={value}>{value}</span>,
    },
    {
      title: "Agency Name",
      key: "2",
      dataIndex: "ACAG_Agency_Name",
      width: "11.11%",
      ellipsis: true,
      render: (value) => <span title={value}>{value}</span>,
    },
    {
      title: "Available Points",
      key: "3",
      dataIndex: "ACAG_Available_Points",
      width: "11.11%",
      align: "right",
      render: (_, data) => {
        return (
          <p
            style={{
              textAlign: "right",
            }}
          >
            {_?.toLocaleString()}
          </p>
        );
      },
    },
    {
      title: "Redeemable Points",
      key: "4",
      dataIndex: "ACAG_Points_Redeemed",
      width: "11.11%",
      align: "right",
      render: (_, data) => {
        return (
          <p
            style={{
              textAlign: "right",
            }}
          >
            {_?.toLocaleString()}
          </p>
        );
      },
    },
    {
      title: "Pending Requests",
      key: "5",
      dataIndex: "PendingRequest",
      width: "11.11%",
      align: "right",
      render: (_, data) => {
        return (
          <p
            style={{
              textAlign: "right",
            }}
          >
            {_?.toLocaleString()}
          </p>
        );
      },
    },
    {
      title: "Onboarding",
      key: "10",
      dataIndex: "ACAG_Onboarding_Allowed",
      width: "11.11%",
      render: (_, object) => (
        <Tag
          style={{
            border: "none",
            width: 66,
            textAlign: "center",
            borderRadius: 10,
            color: object.ACAG_Onboarding_Allowed ? colors.grey900 : colors.white,
            backgroundColor: object.ACAG_Onboarding_Allowed
              ? colors.green500
              : colors.red200,
          }}
        >
          {object.ACAG_Onboarding_Allowed ? "True" : "False"}
        </Tag>
      ),
    },
    {
      title: "Status",
      key: "6",
      dataIndex: "ACAG_Is_Active",
      width: "11.11%",
      render: (_, object) => (
        <Tag
          style={{
            border: "none",
            width: 66,
            textAlign: "center",
            borderRadius: 10,
            color: colors.grey900,
            backgroundColor: object.ACAG_Is_Active
              ? colors.green500
              : colors.red300,
          }}
        >
          {object.ACAG_Is_Active ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Notes",
      key: "7",
      dataIndex: "notes",
      width: "11.11%",
      render: (_, object) => (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Popover
            placement="leftTop"
            title={
              <p style={{ fontSize: 14, fontWeight: 500, color: colors.black }}>
                Notes
              </p>
            }
            content={popoverContent}
            trigger="click"
          >
            <Button type="link" onClick={() => getNotesById(object?.ACAG_KeyID)}>
              <Image src={noteIcon} alt="normandy" preview={false} />
            </Button>
          </Popover>
        </div>
      ),
    },
    {
      title: "Edit",
      key: "8",
      dataIndex: "edit",
      width: "11.11%",
      render: (_, object) => (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button type="link">
            <Image
              src={editIcon}
              onClick={() => {
                setIsEdit((prevState) => !prevState);
                editDetail(object.ACAG_KeyID);
              }}
              alt="normandy"
              preview={false}
            />
          </Button>
        </div>
      ),
    },
  ];
